import React from "react";
import { Lock, ShieldAlert } from "lucide-react";

/**
 * Display a field value. If the value is null/undefined and `restricted` is true,
 * render a clear restricted-state block instead of hiding the field.
 */
export function DataField({ label, value, restricted = false, mono = false, testid }) {
  const isEmpty = value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0);

  if (restricted && isEmpty) {
    return (
      <div className="space-y-1.5" data-testid={testid}>
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#8A857D]">{label}</div>
        <div className="sk-restricted-card rounded-md px-3 py-3 flex items-center gap-2 text-[12px] text-[#B45B3E]">
          <Lock className="w-3.5 h-3.5" strokeWidth={2} />
          <span className="font-medium tracking-tight">Restricted · Cultural Authority Required</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-1.5" data-testid={testid}>
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#8A857D]">{label}</div>
      <div className={`text-[14px] leading-relaxed text-[#2C2A28] ${mono ? "font-mono-data" : ""}`}>
        {isEmpty ? <span className="text-[#8A857D]">—</span> : String(value)}
      </div>
    </div>
  );
}

export function RestrictedNotice({ children = "Some cultural fields are restricted for your role." }) {
  return (
    <div className="sk-restricted-card rounded-md px-4 py-3 flex items-start gap-2 text-[12.5px] text-[#B45B3E]">
      <ShieldAlert className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.8} />
      <span>{children}</span>
    </div>
  );
}

export function SectionTitle({ icon: Icon, title, subtitle, accent }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-5">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="w-9 h-9 rounded-md bg-[#F4F1EA] border border-[#E6E2D8] flex items-center justify-center shrink-0">
            <Icon className="w-4 h-4 text-[#8B5A2B]" strokeWidth={1.6} />
          </div>
        )}
        <div>
          <h2 className="font-display text-[1.4rem] font-semibold tracking-tight text-[#2C2A28]">{title}</h2>
          {subtitle && <p className="text-[13px] text-[#5C5854] mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {accent}
    </div>
  );
}
